const env = window as any;
export class EnvConfig {
  static API_URL = env.API_URL;

  static SENTRY_ENVIRONMENT = env.SENTRY_ENVIRONMENT;
}
